import styled from "styled-components";

const Chip = styled.button`
  border: none;
  border-radius: 999px;
  padding: 0.4rem 0.9rem;
  font-size: 0.8rem;
  font-weight: 600;
  transition: background 0.2s ease, color 0.2s ease, transform 0.15s ease;
  background: ${(p) => (p.$active ? "var(--color-primary)" : "#fff")};
  color: ${(p) => (p.$active ? "#fff" : "#525252")};
  border: 1px solid ${(p) => (p.$active ? "var(--color-primary)" : "#e0e0e0")};
  white-space: nowrap;

  &:hover {
    transform: translateY(-1px);
    background: ${(p) => (p.$active ? "color-mix(in srgb, var(--color-primary) 90%, black)" : "var(--color-primary-soft)")};
    color: ${(p) => (p.$active ? "#fff" : "var(--color-primary)")};
  }
`;

export default function InvestorFilterPills({ options = [], value, onChange }) {
  return (
    <div className="d-flex flex-wrap gap-2 mb-4 investor-filter-pills">
      {options.map((option) => (
        <Chip
          key={option}
          type="button"
          $active={value === option}
          onClick={() => onChange?.(option)}
          aria-pressed={value === option}
        >
          {option}
        </Chip>
      ))}
    </div>
  );
}
